import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from './types'

export const getAdGroupFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post('/api/ad_group_facts/aggregate/banner/', params, {
        headers: getCerebroHeaders(options.headers),
    })

export const getAdGroupFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/ad_group_facts/aggregate/banner/export/',
        params
    )

export const asyncUpdateAdGroupFacts = (
    data: any,
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch(
        '/api/ad_group_facts/aggregate/banner/mutate/',
        data,
        {
            params: { ...params, metrics: null },
            headers: getCerebroHeaders(options.headers),
        }
    )
